import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedNumber } from 'react-intl';

import { FiatCurrency } from '@sorare/core/src/__generated__/globalTypes';
import { MonetaryRewardDisclaimer } from '@sorare/core/src/components/jonum/MonetaryRewardDisclaimer/index.tsx';
import { useMonetaryAmount } from '@sorare/core/src/hooks/useMonetaryAmount';

import type { UsdRewardAmount_monetaryAmount } from './__generated__/index.graphql.ts';

type Props = {
  monetaryAmount: UsdRewardAmount_monetaryAmount;
} & (
  | { variant: 'monetary' }
  | { variant: 'conversionCredit'; percentageDiscount: number }
);

export const UsdRewardAmount = ({ monetaryAmount, ...disclaimer }: Props) => {
  const { toMonetaryAmount } = useMonetaryAmount();

  return (
    <MonetaryRewardDisclaimer {...disclaimer}>
      <FormattedNumber
        value={toMonetaryAmount(monetaryAmount).usd}
        style="currency"
        currency={FiatCurrency.USD}
        currencyDisplay="narrowSymbol"
        maximumFractionDigits={0}
      />
    </MonetaryRewardDisclaimer>
  );
};

UsdRewardAmount.fragments = {
  monetaryAmount: gql`
    fragment UsdRewardAmount_monetaryAmount on MonetaryAmount {
      ...useMonetaryAmount_monetaryAmount
    }
    ${useMonetaryAmount.fragments.monetaryAmount}
  ` as TypedDocumentNode<UsdRewardAmount_monetaryAmount>,
};
